import { render, staticRenderFns } from "./PhotoUploadGridModule.vue?vue&type=template&id=6faa28ca&scoped=true&"
import script from "./PhotoUploadGridModule.vue?vue&type=script&lang=js&"
export * from "./PhotoUploadGridModule.vue?vue&type=script&lang=js&"
import style0 from "./PhotoUploadGridModule.vue?vue&type=style&index=0&id=6faa28ca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6faa28ca",
  null
  
)

export default component.exports